import type { ScheduleTab, SessionStatus } from './types';

export const scheduleTabs: ScheduleTab[] = ['All', 'Upcoming', 'Completed', 'Missed', 'Recordings'];

export const sessionStatusStyles: Record<SessionStatus, string> = {
  Active: 'bg-emerald-100 text-emerald-700',
  Scheduled: 'bg-blue-100 text-blue-700',
  Completed: 'bg-green-100 text-green-700',
  Missed: 'bg-red-100 text-red-700',
  Cancelled: 'bg-gray-100 text-gray-700',
};

export const eventStyles = [
  'border-blue-200 bg-blue-50 text-blue-700',
  'border-emerald-200 bg-emerald-50 text-emerald-700',
  'border-amber-200 bg-amber-50 text-amber-700',
  'border-violet-200 bg-violet-50 text-violet-700',
];

export const fallbackSlots = [
  { start: '10:00', end: '11:00' },
  { start: '14:00', end: '16:00' },
  { start: '16:30', end: '17:00' },
];

export const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

export const slotMinutes = 30;

export const slotHeight = 24;
